import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import plugins from './plugins'
import App from './App.vue'
import router from './app-routing'
import store from './store/index'

import '@styles/styles.scss'

import { Form, Message } from 'ant-design-vue'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://efa26538720b457ca93a2e22dcb7185d@trap.cekid.com/35',
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
        release: '', // --sentry release--
        whitelistUrls: [/haiziwang\.com/, /cekid\.com/]
    });
}

if (window != top) {
    top.location.href = `${process.env.VUE_APP_SEVERENV === 'IDC' ? 'https' : 'http'}://open.haiziwang.com/auth/login`
}

Vue.use(Form)
Vue.use(Message)
Vue.use(plugins)

Vue.prototype.$form = Form
Vue.prototype.$message = Message

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')